import BaseService from "../baseService";
class NfeNcm extends BaseService {
  constructor(id) {
    const resource = "keycloak/client-roles";
    let relationship = {};
    super(id, relationship, resource);
  }
}

export default (id) => new NfeNcm(id);
